import { ClientRequestDetails, ClientRequestDocumentActivity } from '@aiwyn/api';

export function getFlaggedFilesIds(documentActivity: ClientRequestDocumentActivity[], details: ClientRequestDetails): number[] {
  const flaggedFiles = [];

  for (const section of details?.sections ?? []) {
    for (const item of section.items) {
      for (const file of item?.files ?? []) {
        if (file.isFlagged) {
          flaggedFiles.push(file.file?.id);
        }
      }
    }
  }
  for (const doc of documentActivity) {
    for (const file of doc.files) {
      if (file.is_flagged) {
        flaggedFiles.push(file.id);
      }
    }
  }

  return flaggedFiles;
}
